import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { push } from 'react-router-redux';

import { loadApp, onRedirect } from '../actions';

import { default as RouterConfig, ModalRouterConfig } from '../router';

import Loading from './helpers/Loading';

import Intercom from './counters/Intercom';
// import GoogleAnalytics from './counters/GoogleAnalytics';
// import PostAffTracker from './counters/PostAffTracker';
import { currentUserSelector } from '../reducers/selectors';

// import { IntlProvider } from 'react-intl';

const mapStateToProps = state => ({ currentUser:currentUserSelector(state), appLoading:state.loaders.app, projectLoading:state.loaders.currentProject, ...state.app });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ loadApp, onRedirect, handleRedirect:push }, dispatch);
};

// const getLang = () => {
//  if (navigator.languages !== undefined) 
//    return navigator.languages[0]; 
//  else 
//    return navigator.language;
// }

class App extends Component {
  
  // constructor(props) {
//     super(props);
// //    this.state = {
// //      fb: {}
// //    };
//   }
//
  componentWillReceiveProps(nextProps) {
    if (nextProps.redirectTo) {
      this.props.handleRedirect(nextProps.redirectTo);
      // this.props.onRedirect();
    }
  }
  
  componentWillMount() {
    const { loadApp } = this.props
    loadApp();
  }
  
  
  // responseFacebook (response) {
  //   console.log(response);
  //   this.setState({fb:response});
  //   window.FB.api('/act_369321070/adspixels', {fields: "id,name"}, console.log);
  // }
  
  
  render() {
    const { appLoading } = this.props;
    // const { fb } = this.state;
    // const lang = getLang();
    
    if (appLoading === true )
      return <Loading />;
    else
      return (<React.Fragment>
        <Intercom appId="ap0oazwb" />
        <RouterConfig />
        <ModalRouterConfig />
      </React.Fragment>);
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/components/App.js